<div class="modal-header">
  <h5 class="modal-title">
    <span *ngIf="!readOnly">New </span>Fax
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <form [formGroup]="faxDetails" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Fax Number:</label>
      <div class="col-sm-9">
        <input type="text" 
               class="form-control" 
               formControlName="faxNumber">
      </div>
    </div>

    <div class="mb-3" *ngIf="caseFiles.length > 0">
      <div class="d-flex align-items-start">
        <div class="me-2">
          <fa-icon [icon]="faPaperclip" size="lg"></fa-icon>
        </div>
        <div class="flex-grow-1">
          <div *ngFor="let file of caseFiles" class="d-flex align-items-center mb-1">
            <span class="me-2">{{file.fileName}}</span>
            <button *ngIf="!readOnly" 
                    type="button" 
                    class="btn btn-sm btn-link text-danger p-0" 
                    (click)="removeAttachment(file.caseFileId)"
                    title="Remove">
              X
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Message</label>
      <textarea class="form-control" 
                #messageBody
                formControlName="messageBody" 
                rows="6"></textarea>
    </div>

  </form>

  <div *ngIf="readOnly">
    <div class="mb-2">
      <strong>Created:</strong> {{faxObj.queuedDate | date:'dd/MM/yyyy HH:mm'}}
    </div>
    <div class="mb-2">
      <strong>Sent:</strong> {{faxObj.sentDate | date:'dd/MM/yyyy HH:mm'}}
    </div>
  </div>

</div>

<div class="modal-footer" *ngIf="!readOnly">
  <button type="button" 
          class="btn btn-success" 
          (click)="sendFax()" 
          [disabled]="sendingFax || faxDetails.invalid">
    <span *ngIf="sendingFax" class="spinner-border spinner-border-sm me-2"></span>
    Send
  </button>
</div>